module.exports = __webpack_public_path__ + "img/calendar.4a859813.svg";